import { render, staticRenderFns } from "./_template-error.vue?vue&type=template&id=5b180c4a&scoped=true&"
import script from "./_template-error.vue?vue&type=script&lang=js&"
export * from "./_template-error.vue?vue&type=script&lang=js&"
import style0 from "./_template-error.vue?vue&type=style&index=0&id=5b180c4a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b180c4a",
  null
  
)

export default component.exports